import Navbar from "@/components/layout/Navbar";
import { useAuth } from "@/hooks/useAuth";
import { StickyFastPath } from "@/components/landing/StickyFastPath";
import { FrameHero } from "@/components/landing/frames/FrameHero";
import { FrameDormant } from "@/components/landing/frames/FrameDormant";
import { FrameExtraction } from "@/components/landing/frames/FrameExtraction";
import { FrameProof1 } from "@/components/landing/frames/FrameProof1";
import { FrameVelocity } from "@/components/landing/frames/FrameVelocity";
import { FramePlatformMatrix } from "@/components/landing/frames/FramePlatformMatrix";
import { FrameLiveExtraction } from "@/components/landing/frames/FrameLiveExtraction";
import { FrameMechanism } from "@/components/landing/frames/FrameMechanism";
import { FrameDeployment } from "@/components/landing/frames/FrameDeployment";
import { LandingFooter } from "@/components/landing/LandingFooter";

const Index = () => {
  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      
      {/* Sticky fast path CTA */}
      <StickyFastPath isLoggedIn={isLoggedIn} />

      {/* 1. Hero — poster-worthy, logo-centered */}
      <FrameHero isLoggedIn={isLoggedIn} />

      {/* 2. The Problem — dormant praise */}
      <FrameDormant />

      {/* 3. The Promise — what if? */}
      <FrameExtraction />

      {/* 4. The Proof — before/after */}
      <FrameProof1 />

      {/* 5. Speed — 60 seconds */}
      <FrameVelocity />

      {/* 6. Platform formats */}
      <FramePlatformMatrix />

      {/* 7. Live Demo */}
      <FrameLiveExtraction />

      {/* 8. How it works */}
      <FrameMechanism />

      {/* 9. Final CTA */}
      <FrameDeployment isLoggedIn={isLoggedIn} />

      {/* Footer */}
      <LandingFooter />
    </main>
  );
};

export default Index;
